import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { useTranslationApp } from "../../../../lib/i18next";
import { MODAL_COMPETITORS_STRONG_SIGNAL } from "../../../../i18n/keysTranslations";
import { isCompetitorAdStrongSignal } from "../../../../services/competitorAdsGallery";
import { GREEN_COLOR } from "../../../../utils/colors";

const STRONG_SIGNAL_CHIP_BG = "rgba(26, 137, 37, 0.12)";

const CompetitorStrongSignalChip = ({ activeDurationHours }) => {
  const { t } = useTranslationApp();

  if (!isCompetitorAdStrongSignal(activeDurationHours)) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.25,
        backgroundColor: STRONG_SIGNAL_CHIP_BG,
        borderRadius: 2,
        px: 0.75,
        py: 0.5,
        flexShrink: 0,
        lineHeight: 1,
      }}
    >
      <TrendingUpIcon
        sx={{
          color: "#1A8925 !important",
          fontSize: 11,
          flexShrink: 0,
          marginTop: 0.125,
          marginRight: 0.3,
        }}
      />
      <Typography
        variant="caption"
        component="span"
        sx={{
          color: GREEN_COLOR,
          fontWeight: 600,
          fontSize: "0.625rem",
          lineHeight: 1.2,
          whiteSpace: "nowrap",
        }}
      >
        {t(MODAL_COMPETITORS_STRONG_SIGNAL)}
      </Typography>
    </Box>
  );
};

export default CompetitorStrongSignalChip;
